// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calendarGridWeek {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.calendarGridWeek_header {
    padding: 10px 0;
    border-bottom: 1px solid #e0e0e0;
    margin-bottom: 10px;
}

.calendarGridWeek_date {
    font-size: 24px;
    font-weight: 600;
    color: #333;
    margin: 0;
    padding-left: 16px;
    text-transform: capitalize;
}

.calendarGridWeek_dates{
    display: flex;
    flex-wrap: wrap;
    --cols: 7;
    width: 100%;  
}

.calendarGridWeek_dates--main{
    height: 100%;
}

.calendarGridWeek_day{
    border: 1px solid #e0e0e0;
    width: calc(100% / var(--cols));
    flex-shrink: 0;
    position: relative;
    min-height: 120px;
    padding: 8px 4px;
    cursor: pointer;

    font-weight: 400;
    font-size: calc(12px * var(--fontScaler));
    line-height: 19px;
    color: #000000;
}

.calendarGridWeek_day:hover {
    background-color: #f8f9fa;
}

.calendarGridWeek_day--head{
    height: 40px;
    min-height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f8f9fa;
    font-weight: 600;
    font-size: 12px;
    color: #666;
    text-transform: uppercase;
}

.calendarGridWeek_day_number {
    font-weight: 600;
    font-size: 16px;
    color: #000;
    margin-bottom: 8px;
}

.calendarGridWeek_ticket{
    background: var(--ticket-color-back);
    border-radius: 3px;
    border-left: 3px solid var(--ticket-color-side);
    padding: 4px;
    width: 100%;
    color: var(--ticket-color);
    margin-bottom: 2px;
    display: flex;
    align-items: baseline;
    gap: 4px;
    cursor: pointer;
}

.calendarGridWeek_ticket:hover {
    opacity: 0.8;
}`, "",{"version":3,"sources":["webpack://./src/components/calendarGrid/CalendarGridWeek.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,SAAS;IACT,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,+BAA+B;IAC/B,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;;IAEf,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,+CAA+C;IAC/C,YAAY;IACZ,WAAW;IACX,0BAA0B;IAC1B,kBAAkB;IAClB,aAAa;IACb,qBAAqB;IACrB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB","sourcesContent":[".calendarGridWeek {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n}\n\n.calendarGridWeek_header {\n    padding: 10px 0;\n    border-bottom: 1px solid #e0e0e0;\n    margin-bottom: 10px;\n}\n\n.calendarGridWeek_date {\n    font-size: 24px;\n    font-weight: 600;\n    color: #333;\n    margin: 0;\n    padding-left: 16px;\n    text-transform: capitalize;\n}\n\n.calendarGridWeek_dates{\n    display: flex;\n    flex-wrap: wrap;\n    --cols: 7;\n    width: 100%;  \n}\n\n.calendarGridWeek_dates--main{\n    height: 100%;\n}\n\n.calendarGridWeek_day{\n    border: 1px solid #e0e0e0;\n    width: calc(100% / var(--cols));\n    flex-shrink: 0;\n    position: relative;\n    min-height: 120px;\n    padding: 8px 4px;\n    cursor: pointer;\n\n    font-weight: 400;\n    font-size: calc(12px * var(--fontScaler));\n    line-height: 19px;\n    color: #000000;\n}\n\n.calendarGridWeek_day:hover {\n    background-color: #f8f9fa;\n}\n\n.calendarGridWeek_day--head{\n    height: 40px;\n    min-height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #f8f9fa;\n    font-weight: 600;\n    font-size: 12px;\n    color: #666;\n    text-transform: uppercase;\n}\n\n.calendarGridWeek_day_number {\n    font-weight: 600;\n    font-size: 16px;\n    color: #000;\n    margin-bottom: 8px;\n}\n\n.calendarGridWeek_ticket{\n    background: var(--ticket-color-back);\n    border-radius: 3px;\n    border-left: 3px solid var(--ticket-color-side);\n    padding: 4px;\n    width: 100%;\n    color: var(--ticket-color);\n    margin-bottom: 2px;\n    display: flex;\n    align-items: baseline;\n    gap: 4px;\n    cursor: pointer;\n}\n\n.calendarGridWeek_ticket:hover {\n    opacity: 0.8;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
